import guideTourForceClickHand from '../assets/guide-tour-force-click-hand.png'

import { forceClickHandImageSizePx, ForceClickHandImage } from './styles'

export const GuideTourForceClickHandIcon = () => (
  <ForceClickHandImage
    src={guideTourForceClickHand}
    alt=""
    width={forceClickHandImageSizePx}
    height={forceClickHandImageSizePx}
    draggable={false}
  />
)
